import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAdvanceTransactionList,
  createOrUpdateAdvanceTransaction,
  deleteAdvanceTransaction,
  fetchFromAccounts,
  fetchToAccounts,
  fetchContraCode,
} from "./advanceTransactionThunks";

const advanceTransactionSlice = createSlice({
  name: "advanceTransaction",
  initialState: {
    transactions: [],
    fromAccounts: [],
    toAccounts: [],    
    contraCode: "",
    loading: false,
    error: null,
    selectedAdvanceTransaction: null,
    isEditAdvanceTransaction: false,
  },
  reducers: {
    setSelectedAdvanceTransaction: (state, action) => {
      state.selectedAdvanceTransaction = action.payload;
    },
    setIsEditAdvanceTransaction: (state, action) => {
      state.isEditAdvanceTransaction = action.payload;
    },
    clearToAccounts: (state) => {
      state.toAccounts = [];
    },
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdvanceTransactionList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAdvanceTransactionList.fulfilled, (state, action) => {
        state.loading = false;
        state.transactions = action.payload;
      })
      .addCase(createOrUpdateAdvanceTransaction.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteAdvanceTransaction.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchFromAccounts.fulfilled, (state, action) => {
        state.fromAccounts = action.payload;
      })
      .addCase(fetchToAccounts.fulfilled, (state, action) => {
        state.toAccounts = action.payload;
      })
      .addCase(fetchContraCode.fulfilled, (state, action) => {
        state.contraCode = action.payload;
      });
  },
});

export const {
  setSelectedAdvanceTransaction,
  setIsEditAdvanceTransaction,
  clearToAccounts,
} = advanceTransactionSlice.actions;
export default advanceTransactionSlice.reducer;
